document.addEventListener("DOMContentLoaded", function () {
    function setThumbSize() {
        let viewer = document.querySelector(".media-viewer");
        let thumb = document.querySelector(".media-thumbs");

        if (viewer && thumb && window.matchMedia("(min-width: 768px)").matches) {
            // Desktop: Set vertical height
            let viewerHeight = viewer.offsetHeight;
            thumb.style.height = viewerHeight + "px";
            thumb.style.overflowY = "auto";
            thumb.style.overflowX = "hidden"; // No horizontal scrolling
        }
    }

    function initVerticalThumbs() {
        if (window.matchMedia("(min-width: 768px)").matches) {
            const thumbWrapper = document.querySelector(".media-thumbs");
            const prevBtn = document.querySelector(".thumb-nav.prev");
            const nextBtn = document.querySelector(".thumb-nav.next");

            if (!thumbWrapper || !prevBtn || !nextBtn) return;

            const scrollAmount = 80;

            function updateButtonState() {
                const totalThumbsHeight = thumbWrapper.scrollHeight;
                const visibleHeight = thumbWrapper.clientHeight;

                const isPrevDisabled = thumbWrapper.scrollTop <= 0;
                const isNextDisabled = thumbWrapper.scrollTop + visibleHeight >= totalThumbsHeight;

                prevBtn.style.display = isPrevDisabled ? "none" : "block";
                nextBtn.style.display = isNextDisabled ? "none" : "block";
            }

            prevBtn.addEventListener("click", () => {
                thumbWrapper.scrollBy({ top: -scrollAmount, behavior: "smooth" });
            });

            nextBtn.addEventListener("click", () => {
                thumbWrapper.scrollBy({ top: scrollAmount, behavior: "smooth" });
            });

            thumbWrapper.addEventListener("scroll", updateButtonState);
            updateButtonState();
        }
    }

    function initializeGallery() {
        setThumbSize();
        initVerticalThumbs();
    }

    initializeGallery();
    window.addEventListener("resize", initializeGallery);
});



// Fixed double slide change issue


document.addEventListener('touchstart', function(e){

    const btn = e.target.closest(
        '.pwwp__button--arrow--right, .pwwp__button--arrow--left'
    );

    if (btn) {
        btn.dataset.touchstarted = 'true';
    }

}, { passive:true });

document.addEventListener('click', function(e){

    const btn = e.target.closest(
        '.pwwp__button--arrow--right, .pwwp__button--arrow--left'
    );

    if (!btn) return;

    if (btn.dataset.touchstarted === 'true') {
        btn.dataset.touchstarted = 'false';
        e.stopImmediatePropagation();
    }

}, true);

